


























import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseIconButton",
  components: { BaseIcon, BaseSpinner },
  props: {
    fontSize: { type: [String, Number], default: 24 },
    color: { type: String },
    showIndicator: { type: Boolean },
    to: { type: Object as () => Location },
    href: { type: String },
    medium: { type: Boolean },
    size: { type: Number },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean },
    spinnerColor: { type: String },
    light: { type: Boolean },
    dark: { type: Boolean },
    primary: { type: Boolean },
  },
  setup(props) {
    const styles = computed(() => ({
      width: props.size + "px",
      height: props.size + "px",
    }));

    return { styles };
  },
});
